"use client";

import { c as _c } from "react/compiler-runtime";
import { useTrustpilotRating } from "@/queries/useTrustpilotRating";
import TrustpilotServiceRating from "./TrustpilotServiceRating";
export default function TrustpilotServiceReviewsClient() {
  const $ = _c(3);
  const {
    data
  } = useTrustpilotRating();
  if (!data) {
    return null;
  }
  let t0;
  if ($[0] !== data.rating || $[1] !== data.ratingLabel) {
    t0 = <TrustpilotServiceRating rating={data.rating} ratingLabel={data.ratingLabel} />;
    $[0] = data.rating;
    $[1] = data.ratingLabel;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
}